import { createSlice } from "@reduxjs/toolkit";

const initialState = { apiKeys: [], apiKeyDetails: null };

export const apiKeySlice = createSlice({
  name: "apiKey",
  initialState,
  reducers: {
    setApiKeyList: (state, { payload }) => {
      return {
        ...state,
        apiKeys: payload,
      };
    },

    setApiKeyDetails: (state, { payload }) => {
      return {
        ...state,
        apiKeyDetails: payload,
      };
    },

    addApiKey: (state, { payload }) => {
      return {
        ...state,
        apiKeys: [...state.apiKeys, payload],
      };
    },

    updateApiKey: (state, { payload }) => {
      return {
        ...state,
        apiKeys: state.apiKeys.map((key) =>
          key._id === payload._id ? payload : key
        ),
      };
    },

    deleteApiKey: (state, { payload }) => {
      return {
        ...state,
        apiKeys: state.apiKeys.filter((key) => key._id !== payload),
      };
    },
  },
});
